import { Grid, Table, TableBody, TableCell,Button, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { Fragment, memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useStyle } from '../style'
import axios from 'axios'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import _ from 'lodash'
import { Helmet } from 'react-helmet-async'
import dayjs from 'dayjs'
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import * as XLSX from 'xlsx';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';

import moment from 'moment'
const GstReport = () => {
    const dispatch = useDispatch()
    const classes = useStyle()
    const [data,setData] = useState([])

    const [dateLimit, setDateLimit] = useState({
      fromDate : moment().subtract(1, 'months').format(),
      toDate : moment().format()
    })
    function handleChange(e, name) {
      setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
    }
    function getGstLedger (){
      const postData = {
        from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
        to_date:moment(dateLimit.toDate).format('YYYY-MM-DD'),
      }
        axios.post('/v1/reports/hsn/gstledger',postData)
        .then(res=>{
            const  response  = res.data
            // setData(res.data)
            const combinedData = [];
// console.log(response)
// Combine purchase and sales data
response!==null && response.purchase.forEach(purchaseItem => {
  const combinedItem = { ...purchaseItem, total : purchaseItem.amount + purchaseItem.cess_amt + purchaseItem.gst_amt + purchaseItem.igst_amt };
  const salesItem = response.sales.find(salesItem => salesItem.hsn === purchaseItem.hsn);
  if (salesItem) {
    // combinedData.total = purchaseItem.amount + purchaseItem.cess_amt + purchaseItem.gst_amt + purchaseItem.igst_amt;
    combinedItem.gst_sales = salesItem.gst_per;
    combinedItem.sales_amount = salesItem.amount;
    combinedItem.sales_cess_amt = salesItem.cess_amt;
    combinedItem.sales_gst_amt = salesItem.gst_amt;
    combinedItem.sales_igst_amt = salesItem.igst_amt;
    combinedItem.sales_total = salesItem.amount + salesItem.cess_amt + salesItem.gst_amt + salesItem.igst_amt;

  } else {
    combinedItem.gst_sales = "";
    combinedItem.sales_amount = "";
    combinedItem.sales_cess_amt = "";
    combinedItem.sales_gst_amt = "";
    combinedItem.sales_igst_amt = "";
    combinedItem.sales_total =""
  }
  combinedData.push(combinedItem);
});

// Add sales items not present in purchase
response!==null && response.sales.forEach(salesItem => {
  const exists = combinedData.some(combinedItem => combinedItem.hsn === salesItem.hsn);
  if (!exists) {
    combinedData.push({
      gst_per: "",
      amount: "",
      total:'',
      gst_sales: salesItem.gst_per,
      sales_amount: salesItem.amount,
      sales_cess_amt : salesItem.cess_amt,
      sales_gst_amt : salesItem.gst_amt,
      sales_igst_amt : salesItem.igst_amt,
      sales_total : salesItem.amount + salesItem.cess_amt + salesItem.gst_amt + salesItem.igst_amt
    });
  }
});

console.log(combinedData);
setData(combinedData)
        })
        .catch(err=>{
            console.log(err)
            dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
        })
    }
    function exportToExcel() {
      const wb = XLSX.utils.book_new();
      const wsData = data.map(item => [
        item.hsn,
        item.amount,
        item.amount === '' ? '' : item.amount / 2,
        item.amount === '' ? '' : item.amount / 2,
        item.igst_amt,
        item.cess_amt,
        item.total === "" ? "" : parseFloat(item.total).toFixed(0),
        item.sales_amount,
        item.gst_amt === '' ? "" : item.gst_amt / 2,
        item.gst_amt === '' ? "" : item.gst_amt / 2,
        item.sales_igst_amt,
        item.sales_cess_amt,
        item.sales_total === "" ? "" : parseFloat(item.sales_total).toFixed(0)
      ]);
    
      const ws = XLSX.utils.aoa_to_sheet([
        [
          'Purchase', 
          '',
          '',
          '',
          '',
          '',
          '',
          'Sales', 
          '',
          '',

        ],
        [
          'HSN',
          'Cash',
          'SGST',
          'CGST',
          'IGST',
          'CESS',
          'Total',
          'Cash',
          'SGST',
          'CGST',
          'IGST',
          'CESS',
          'Total'
        ],
        ...wsData
      ]);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "Hsn Report.xlsx");
    }
    
    
    useEffect(()=>{
        getGstLedger()
    },[dateLimit])
  return (
<Fragment>
    <Helmet><title>Hsn Report</title></Helmet>
    <Typography variant='h6'>HSN Report</Typography>
    <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <Grid className='text-end my-2'>
    <Button onClick={exportToExcel} variant="outlined" > Export to Excel <SimCardDownloadOutlinedIcon /></Button>
      </Grid>
    <Grid className='flex'>
        <TableContainer className={classes.tblRoot}>
            <Table>
                <TableHead className={classes.tblHeader}>
                    <TableRow className={classes.tablrow}>
                        <TableCell sx={{borderLeft:`1px solid #ccc`}} className={classes.tblContentCell} colSpan={7} align='center'>Purchase</TableCell>
                        <TableCell sx={{borderLeft:`1px solid #ccc`}} className={classes.tblContentCell} colSpan={7} align='center'>Sales</TableCell>
                    </TableRow>
                    <TableRow className={classes.tablrow}>
                        <TableCell  sx={{borderLeft:`1px solid #ccc`}}>HSN</TableCell>
                        <TableCell >Cash</TableCell>
                        <TableCell>SGST</TableCell>
                        <TableCell>CGST</TableCell>
                        <TableCell>IGST</TableCell>
                        <TableCell>CESS</TableCell>
                        <TableCell>Total</TableCell>
                        <TableCell >Cash</TableCell>
                        <TableCell>SGST</TableCell>
                        <TableCell>CGST</TableCell>
                        <TableCell>IGST</TableCell>
                        <TableCell>CESS</TableCell>
                        <TableCell>Total</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
               
                          {data.length > 0 && _.map(data,(val, idx)=>(    
                     <TableRow className={classes.tablrow1} key={idx}>
                            <TableCell sx={{borderLeft: `1px solid #ccc`,textAlign:"center !important"}}>{val.hsn}</TableCell>
                            <TableCell>{Math.round(val.amount)}</TableCell>
                            <TableCell>{val.gst_amt==='' || !val.gst_amt ? '' : Math.round(val.gst_amt / 2)}</TableCell>
                            <TableCell>{val.gst_amt==='' || !val.gst_amt  ? '' : Math.round(val.gst_amt / 2)}</TableCell>
                            <TableCell>{val.igst_amt}</TableCell>
                            <TableCell>{val.cess_amt}</TableCell>
                            <TableCell sx={{fontWeight:600,textAlign:"right !important"}}>{val.total==="" ? "" : parseFloat(val.total).toFixed(0)}</TableCell>

                            <TableCell>{Math.round(val.sales_amount)}</TableCell>
                            <TableCell>{val.sales_gst_amt==='' ? "" : Math.round(val.sales_gst_amt / 2)}</TableCell>
                            <TableCell>{val.sales_gst_amt==='' ? "" : Math.round(val.sales_gst_amt / 2)}</TableCell>
                            <TableCell>{val.sales_igst_amt}</TableCell>
                            <TableCell>{val.sales_cess_amt}</TableCell>
                            <TableCell sx={{fontWeight:600,textAlign:"right !important"}}>{val.sales_total==="" ? "" : parseFloat(val.sales_total).toFixed(0)}</TableCell>
                     </TableRow>
                        ))}
                </TableBody>
            </Table>
    
        </TableContainer>
    </Grid>
</Fragment>
  )
}

export default memo(GstReport)